import React from 'react';
import { Container } from '@adobe/cq-react-editable-components';

import { FWAContainer } from '../../common/FWAContainer';
import { Row, Col } from '../../common/Grid';
import './registration.css';

import { getPrefetch, isLoggedIn, getSession } from '../../common/Helpers';

import { lazyWithPreload } from '../../common/Helpers/lazyWithPrefetch';
import { checkCartidAndLQResponse } from '../../common/Helpers/commonLog';
import { callPerformanceMeasure } from '../../common/Helpers/performanceMeasure';

export default class registrationpage extends Container {
  constructor(props) {
    super(props);
    checkCartidAndLQResponse('registration');
  }

  componentDidMount() {
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        this.performPreFetch();
      }
    };
    const isSubmitted = getSession('isSubmitted');
    if (isSubmitted === 'Y') {
      const data = {
        pageName: 'registration',
      };
      if (!isLoggedIn()) {
        this.props.updatePdc(data);
      }
    }
  }

  componentDidUpdate() {
    if (this.props.apiLoaded) {
      callPerformanceMeasure();
    }
  }

  performPreFetch = () => {
    if (!getPrefetch()) {
      return;
    }
    const ComponentToPreload = lazyWithPreload(() => import(/* webpackPrefetch: true */ '../../Web/OrderConfirmation/redesign/index'));
    if (typeof ComponentToPreload?.preload === 'function') ComponentToPreload.preload();
  };

  render() {
    const components = this.childComponents;

    const registrationPageComponents = components.filter(
      (item) => !(item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0),
    );
    return (
      <FWAContainer topBufferAuto enableLiveSupport title={this.props.title}>
        <Row className="registrationContainer">
          <Col colSizes={{ mobile: 4, tablet: 10, desktop: 4 }}>
            <div>{registrationPageComponents}</div>
          </Col>
        </Row>
      </FWAContainer>
    );
  }
}
